import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy, OnChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

import { GigyaSessionService } from '../../../app/services/gigya-session.service';
import { ProductViewHelperService } from '../../services/product-view-helper.service';
import { TextEditor } from '../text-editor/text-editor.component';
import { Subscription ,  Subject } from 'rxjs';
import { Recording } from '../recording/recording.component';
import {DomSanitizer} from '@angular/platform-browser';
import { AuthService } from '../../../app/services/auth.service';
import { ProductViewDataService } from 'modules/shared-postlogin/services/product-view-data.service';
import { ElapsedTimePipe } from 'modules/shared-postlogin/pipes/elapsedTime.pipe';
import { GroupHelperService } from 'modules/shared-postlogin/services/groups-helper.service';

@Component({
    selector: 'productive-skill',
    templateUrl: './productive-skill.template.html',
    styleUrls: ['./productive-skill.style.scss'],
    standalone: false
})
export class ProductiveSkill implements OnInit, OnDestroy, OnChanges {
  changesNotSavedSubscription: Subscription;
  pskillSavedSubscription: Subscription;
  showSaveLoader;
  showSubmitLoader;

  showLoader: boolean = true;
  userProfileData : any;
  classData : any;
  hasClassStarted: boolean;

  editorDirty : boolean = false;
  savedInput: string;
  lastSavedTime: Date;

  launchedStatementGenerated = false;

  currentSubmissionTitle = ''; // title updated by user and painted by app
  savedSubmissionTitle: string; // title pointing to the title saved in appState

  maxSubmissionLinksAllowed = 1;
  activeSubmissionLink = {url: '', description: ''}; // the link which is being edited
  activeSubmissionLinkIndex; // to detect which link is being edited or deleted
  currentSubmissionLinks: Array<any> = []; // links updated by user and painted by app
  savedSubmissionLinks: Array<any>; // links updated after saving data in appState
  maxLinkLength = 256; // Maximum link length allowed is upto 256 in group pskill.
  pskillUrlLinkValidationSubscription: Subscription;
  urlValidationError = false; // set this boolean if there is validation error while saving or submitting group-pskill
  
  timeElapsedSinceLastSave: string;
  isUserSaved: boolean = false;

  autoSaveCounter: any;
  timeElapsedCounter: any;

  isHelpMessageVisible: boolean = false; // To show hide help block on click of help icon

  //Recording related Variables
  showRecordingActionButtons: boolean = false; //display save and submit buttons after recording is done
  disableSaveAndSubmitButton = false; //disable save and submit button while saving and submitting
  recordingStarted: boolean = false; //Used to show details of user after recording started
  recordingLaunchedForFirstTime: boolean = false; //needed for launched verb XAPI runner : only for first time recording
  recordingStoppedTime: string; //recordingStoppedTime for showing how much time has elapsed since recording is stopped
  isRecordingSaved = false; //Recording Saved tracker
 
  recordingStoppedTimer: any; //Last Recording recorded Timer 
  isPreviewMode: boolean;
  groupId :string = '';
  groupMembers = [];
  groupDetails : any = {};
  groupData: any;
  isGroupArchived: boolean = false;
  textEditorDisable: boolean = false;
  isTeacherlessClass: boolean = false;
  public resetSubmittedSpeakingPSkillSubject: Subject<void> = new Subject<void>();

  @ViewChild('closeModalBtn') closeBtn : ElementRef;
  @ViewChild(TextEditor) private textEditor: TextEditor;
  @ViewChild('showErrorModalBtn') showErrorModalBtn : ElementRef;

  @ViewChild(Recording) private recording: Recording;

  @ViewChild('showAddLinkModalBtn') showAddLinkModalBtn: ElementRef;
  @ViewChild('addLinkForm') addLinkForm;
  
  analytics: any;
  @Input() passScore: number;
  @Input() pskillSubType: string;
  @Output() isSaveAlertNeeded = new EventEmitter<boolean>();
  
  @Input() pskill:any; 
  @Input('productMeta') productMeta : any;
  @Input('classMeta') classMeta : any;
  public productResultsDisplay: any = {};
  public imageBasePath: string = IMAGES_BASEPATH;

  constructor(private authService: AuthService, 
    private productViewHelperService:ProductViewHelperService,
    private chRef: ChangeDetectorRef,
    private sanitizer:DomSanitizer,
    private productViewDataService: ProductViewDataService,
    private elapsedTimePipe: ElapsedTimePipe,
    private groupHelperService: GroupHelperService  ){}

  ngOnInit() {

    this.userProfileData=  this.authService.getUserData();
    // show error modal if pskill answer not saved
    this.changesNotSavedSubscription = this.productViewHelperService.changesNotSaved.subscribe( () => {
      if( this.pskill.submissionType && this.pskill.submissionType.id == 'speak'){
          this.disableSaveAndSubmitButton = false;
          this.recording.setRecorderState('stopped');
          this.showErrorModalBtn.nativeElement.click();
      } else {
        this.showSubmitLoader = false;    
        this.closeBtn.nativeElement.click();
          setTimeout(() => {
          this.showErrorModalBtn.nativeElement.click();
          }, 500); 
      }
    });

    // Show error modal on validation failure of links while saving and submitting pskill activity
    this.pskillUrlLinkValidationSubscription = this.productViewHelperService.pskillUrlLinkValidation.subscribe((error) => {
      this.urlValidationError = true; // Show validation error message in error modal
      this.showSaveLoader = false; // Hide loader on save button
      this.showSubmitLoader = false; // Hide loader on submit buttom
      this.closeBtn.nativeElement.click();
      this.showErrorModalBtn.nativeElement.click();
  });

    // Update UI params after pskill submitted succesfully
    this.pskillSavedSubscription = this.productViewHelperService.pskillAnsSaved.subscribe( (analyticsData: any) => {
        this.resetProductiveSkill();
        this.timeElapsedSinceLastSave = '';
        this.analytics.lastSubmitted = new Date().getTime();
        this.analytics.submittedOnce = true;
        this.analytics['reattempt-requested'] = false;
        let evaluation = {
          attempt:{},
          gradingStatus: "submitted",
          review:{}
        };
        if (analyticsData.text) {
          evaluation.attempt= {
              response : analyticsData.text,
              timestamp: new Date().getTime()
            };
          if(analyticsData.attribs && analyticsData.attribs.title) {
            evaluation.attempt['attribs'] = {
              title: analyticsData.attribs.title
            };
          }
          if(analyticsData.link) {
            evaluation.attempt['link'] = analyticsData.link;
          }
        }
        if (analyticsData.audioPath){
          evaluation.attempt = {
            files :  {
                audioPath : analyticsData.audioPath
              },
            timestamp: new Date().getTime()
          };
        }
        if (this.analytics.evaluation) {
          this.analytics.evaluation.push(evaluation);
        }
        else{
          this.analytics.evaluation=[evaluation];
        }
        if( this.pskill.submissionType && this.pskill.submissionType.id == 'speak'){
          this.disableSaveAndSubmitButton = false;
          this.recording.setRecorderState('stopped');
        } else {
          this.closeBtn.nativeElement.click();
        }
        this.isSaveAlertNeeded.emit(false);
        this.analytics.evaluation[this.analytics.evaluation.length-1].iconObj = this.productViewDataService.getProductContentHelper().getStatusIconForMarkingContent(this.analytics, this.analytics.evaluation[this.analytics.evaluation.length-1]);
        this.productViewHelperService.getXAPIAnalyticsObject().deleteState(this.pskill.itemid).catch(() => {});
    });

    this.productResultsDisplay = this.productViewHelperService.getProductResultsDisplayData();
    // Do not show submit button if class has no teacher and is not lti launch
    this.isTeacherlessClass = this.userProfileData?.launchType !== 'lti' && this.classMeta?.teacherCount == 0;
  }

  ngOnChanges() {
    this.isPreviewMode = this.productViewHelperService.getIsPreviewMode();
    this.showLoader = true;
    this.productViewHelperService.closeActivityBtnSubject.next({ visible: false });
    this.timeElapsedSinceLastSave = '';
    this.savedInput = "";
    this.lastSavedTime = null;
    this.isHelpMessageVisible = false;

    this.resetProductiveSkill();
    //Recording Variables
    this.getGroupData().then(() => {
      this.getLastSavedInput();
    });
  }


  resetProductiveSkill(){
    this.editorDirty = false;
    this.isUserSaved = false;
    clearInterval(this.autoSaveCounter);
    clearInterval(this.timeElapsedCounter);
    this.autoSaveCounter = null;
    this.timeElapsedCounter = null;
    this.showSaveLoader = false;
    this.showSubmitLoader = false;
    this.launchedStatementGenerated = false;
    this.currentSubmissionTitle = '';
    this.savedSubmissionTitle = '';
    this.currentSubmissionLinks = [];
    this.savedSubmissionLinks = [];

    //Recording related variable
    this.showRecordingActionButtons = false;  
    this.disableSaveAndSubmitButton = false;
    this.recordingStarted = false;
    this.recordingLaunchedForFirstTime = false;
    this.recordingStoppedTime = '';
    clearInterval(this.recordingStoppedTimer);
    this.recordingStoppedTimer = null;
    this.isRecordingSaved = false;
    this.resetSubmittedSpeakingPSkillSubject.next();
  
  } 

  /**
   * gets last pskill user data
   */
  async getLastSavedInput() {
    // Do not get last saved state if user is a teacher
    if (this.isPreviewMode) {
        setTimeout(()=>{ 
          this.showLoader = false; 
          this.productViewHelperService.closeActivityBtnSubject.next({ visible: true });
        }, 500);           
        return;
    }
    const itemid = this.pskill['itemid'];
    let analyticsData = this.productViewDataService.getAnalyticsOfItem(this.productViewHelperService.getProduct(), this.productViewHelperService.getClass(), encodeURIComponent(this.pskill.itemid), (this.pskillSubType == "cup-pskill-group" && this.groupId) ? this.groupId : null).toPromise();
    let options = {};
    if (this.pskillSubType === 'cup-pskill' && this.pskill.submissionType && this.pskill.submissionType.id === 'speak') {
      options = {
        isSignedURLReq: true,
        subType: this.pskillSubType,
        submissionTypeId: this.pskill.submissionType.id
      }
    }
    let stateData = this.productViewHelperService.getXAPIAnalyticsObject().getState(this.pskill.itemid, options);
    let promiseResponse:any = await Promise.all([analyticsData, stateData])
    
    if (itemid !== this.pskill.itemid) {
      // While switching between activities fast, avoid using state and analytics of incorrect item
      return;
    }

    if(promiseResponse[0]) {
      let response = promiseResponse[0];
      this.analytics = response.result.__analytics;
      /**Iterating over the total graded submissions */
      if(this.analytics.evaluation){
        this.analytics.evaluation.forEach((evaluation) => {
          evaluation.iconObj = this.productViewDataService.getProductContentHelper().getStatusIconForMarkingContent(response.result, evaluation);
        })
      }
    }
    if(promiseResponse[1]) {
      let response = promiseResponse[1];
      let itemid = this.pskill.itemid;
      if( response && response[itemid] && !this.textEditorDisable) {
        if(response[itemid].data || response[itemid].link || (response[itemid].attribs && response[itemid].attribs.title)) {
          // load text from state if data is present
          if (response[itemid].data) {
            this.savedInput = response[itemid].data;
          }
          // load links from state if links are present
          if (response[itemid].link) {
            this.currentSubmissionLinks = response[itemid].link;
            this.savedSubmissionLinks = [...this.currentSubmissionLinks];
          }
          // load title from state if present
          if (response[itemid].attribs && response[itemid].attribs.title) {
            this.currentSubmissionTitle = response[itemid].attribs.title;
            this.savedSubmissionTitle = this.currentSubmissionTitle;
          }
          this.lastSavedTime = new Date(response[itemid].timestamp);
          this.editorDirty = true;
          this.isUserSaved = response[itemid].isUserSaved;
          this.timeElapsedSinceLastSave = this.elapsedTimePipe.transform(this.lastSavedTime.getTime());
          this.startTimeElapsedCounter();
          setTimeout(()=>{
            if(this.textEditor) {
              this.textEditor.setSavedInput(this.savedInput);
              this.setActivityDirty(true, false);
            }
          });
        } else if(response[itemid].audioPath) {

          this.showRecordingActionButtons = true; //Show action buttons
          this.isRecordingSaved = true; //Recording is already saved in this case
          this.lastSavedTime = new Date(response[itemid].timestamp);//Get Last Saved Time
          this.timeElapsedSinceLastSave = this.elapsedTimePipe.transform(this.lastSavedTime.getTime());
          this.startTimeElapsedCounter();//Start Counter
          setTimeout(()=>{  
            if(this.recording) {
              this.recording.setRecorderState('stopped'); //Set Recorder State (in child component - recording)
              this.recording.setAudioSrc(response[itemid].audioPath); 
            }
          }, 0);  //Set Audio Src (in child component - recording)
        }
      }
    }
    this.showLoader = false;
    this.productViewHelperService.closeActivityBtnSubject.next({ visible: true });
    if(this.productViewHelperService.getProductClass() && this.productViewHelperService.getProductClass()['instructor'] && this.productViewHelperService.getProductClass()['instructor']['uuid']){
      this.classData =  this.productViewHelperService.getProductClass();
      // Make classData = undefined if class has expired, so that Submit button doesn't show up in expired classes for student view
      if(this.classData.enddate && new Date(this.classData.enddate) < new Date()) {
          this.classData = undefined;
      }
    }
  }

  /**
   * gets group data 
   */
  async getGroupData(){
    /* Reset Group Data */
    this.isGroupArchived = false;
    this.textEditorDisable = false;
    this.groupId = null;
    this.groupDetails = {};
    this.groupMembers = [];
    this.groupData = null;
    /* Reset Group Data - End */

    if(!this.isPreviewMode && this.pskillSubType == 'cup-pskill-group') {
      //Ref NEMO-4032
      let analyticsGroupId = this.productViewHelperService.getAnalyticsGroupIdOfAnItem(this.pskill.itemid, true)
      if(analyticsGroupId) {
        this.groupId = analyticsGroupId;
      } else {
        let activeGroupId = this.groupHelperService.getLearnerActiveGroupId();
        this.groupId = activeGroupId;
      }
      let allGroupsData = this.groupHelperService.getGroups();
      if(allGroupsData && allGroupsData.length) {
        this.isGroupArchived = true;
        allGroupsData.find((groupInfo)=> {
          if(groupInfo.uuid === this.groupId) {
            this.isGroupArchived = groupInfo.archived;
            this.textEditorDisable = groupInfo.archived; /* Disable text if group is archived */
            this.groupDetails.title = groupInfo.title;
            return true;
          }
        })
      }
      this.groupMembers = [];
      if(this.groupId) {
        const groupId = this.groupId;
        this.groupData = await this.groupHelperService.getGroupMembers(this.groupId);
        if(this.groupData && this.groupData.length && groupId === this.groupId)
        {
          this.groupData.forEach((member)=>{
            let name = member.first_name + ' ' + member.last_name;
            this.groupMembers.push(name);
          });
          this.groupDetails =  this.groupData[0].group;
        }
      }
      else{
        this.textEditorDisable = true;
      }
    }
    else if(this.isPreviewMode && this.pskillSubType == 'cup-pskill-group' && !this.groupId) {
      //Disable textarea in teacher's view
      this.textEditorDisable = true;
    }
  }
  submitAnswer() {
      if( this.pskill.submissionType && this.pskill.submissionType.id == 'speak'){
        this.closeBtn.nativeElement.click();
        this.disableSaveAndSubmitButton = true;
        if(this.isRecordingSaved) { //If user saves the audio and then click submit (audio already updated) 
          this.recording.saveOrsubmitRecordedAudio('submit', false);
        } else { //Normal submit
            this.recording.saveOrsubmitRecordedAudio('submit');
        }
      } else { 
        this.showSubmitLoader = true;
        this.saveCurrentInput(true, true);

        let options = {
          result: {
            'response': { text : this.textEditor.getCurrentInput() }
          }
        };
        if(this.pskillSubType == "cup-pskill-group" && this.groupId){
          options["group"] = {
            id: this.groupId
          };
          if (this.currentSubmissionTitle && this.currentSubmissionTitle.trim()) {
            options.result.response['attribs'] = {
              title: this.currentSubmissionTitle.trim()
            };
          }
          if (this.currentSubmissionLinks) {
            options.result.response['link'] = [...this.currentSubmissionLinks];
          }
        }
        this.productViewHelperService.getXAPIRunnerObject().generateCustomStatement(this.pskill.itemid, "submitted", options );
    }
  }

  saveRecording(event?) {
    if(event && event.target.attributes['aria-disabled'] && event.target.attributes['aria-disabled'].nodeValue === 'true') {
      return;
    }
    if(this.closeBtn) this.closeBtn.nativeElement.click();
    this.disableSaveAndSubmitButton = true; 
    this.recording.saveOrsubmitRecordedAudio('save');
  }
  /**
  * subscriber to event for 'text-editor' makred dirty (first input change)
  * initiate counters for auto-save and time-elapsed
  * val is always 'true'
  */
  onEditorDirty(val : boolean) {
    // for first call save input immediately and post "launched" statement
    this.setActivityDirty(true);
    this.editorDirty = val;
  }

  //Called when recording Started in child
  onRecordingStarted(val:boolean) {
    this.isRecordingSaved = false;//Recording Saved tracker
    this.timeElapsedSinceLastSave = '';
    this.lastSavedTime = null;
    this.showRecordingActionButtons = false;
    this.recordingStarted = true; 
    this.isSaveAlertNeeded.emit(true);

    this.recordingStoppedTime = ''; //clear time elapsed since last recording on new Recording start.
    clearInterval(this.recordingStoppedTimer); //clear Timer for time elapsed since last recording.

    //Handling for launched verb
    if (!this.recordingLaunchedForFirstTime) { //recordingLaunchedForFirstTime = false for only first time for tracking launched verb
      this.recordingLaunchedForFirstTime = true;
      //XAPI 'launched' verb
      this.productViewHelperService.getXAPIRunnerObject().generateCustomStatement(this.pskill.itemid, "launched");
    }
  }

  //Called when recording stopped from child
  onRecordingStopped(val:boolean) {
    const recordingStoppedDate = new Date(); //Current Recording Time
    this.recordingStoppedTime = this.elapsedTimePipe.transform(recordingStoppedDate.getTime()); //Convert recordingStoppedTime to specific format
    
    clearInterval(this.recordingStoppedTimer);//????

    this.recordingStoppedTimer = setInterval(() => {
      this.recordingStoppedTime = this.elapsedTimePipe.transform(recordingStoppedDate.getTime());//Update recordingStoopedTime every 10 sec
    }, 10000)

    this.showRecordingActionButtons = true; //Show Action buttons (Save/Submit) 
  }

  //Called after uploading an audio to s3 or attempt failed
  onRecordingSaveorSubmission(saveOrSubmissionObject : any) {
    if(saveOrSubmissionObject.success) { //Upload Succes 

      if(saveOrSubmissionObject.action == 'submit') { //After submission
        //post the submitted statement
        let options = {
          result: {
            'response': { audioPath: saveOrSubmissionObject.audioUrl }
          }
        };
        this.productViewHelperService.getXAPIRunnerObject().generateCustomStatement(this.pskill.itemid, "submitted", options);
      } else if(saveOrSubmissionObject.action == 'save') {

          const currentTime = new Date(); //Audio Saved Time
          const state = {
            [this.pskill.itemid]: {
              "audioPath": saveOrSubmissionObject.audioUrl,
              "timestamp" : currentTime.getTime()
          }};
          //Save the last uploaded audioUrl and time 
          this.productViewHelperService.getXAPIAnalyticsObject().postStateNoBatch(this.pskill.itemid, state, {isSignedURLReq: true, subType: this.pskillSubType, submissionTypeId: this.pskill.submissionType.id}).then((response)=> {
            if (response && response.success && response.count === response.success.count) {
              this.isRecordingSaved = true;//Recording Saved tracker
              this.disableSaveAndSubmitButton = false;//Enable the save buttons
              this.lastSavedTime = currentTime;
              this.timeElapsedSinceLastSave = this.elapsedTimePipe.transform(this.lastSavedTime.getTime());
              this.startTimeElapsedCounter();

              this.recording.setRecorderState('stopped'); 
              this.recording.setAudioSrc(response.success.entities?.[0]?.data?.[this.pskill.itemid].audioPath);

              this.isSaveAlertNeeded.emit(false); //After successful save no need to show alert on navigation
            } else {
              this.disableSaveAndSubmitButton = false;
              this.recording.setRecorderState('stopped');
              this.showErrorModalBtn.nativeElement.click();
            }
          }, (error)=> {
            this.disableSaveAndSubmitButton = false;
            this.recording.setRecorderState('stopped');
            this.showErrorModalBtn.nativeElement.click();
          });
      }
      
    } else { //Upload fail
      this.disableSaveAndSubmitButton = false;
      this.recording.setRecorderState('stopped');
      this.showErrorModalBtn.nativeElement.click();
    }
  }

  /**
   * saves current user input in text-editor and
   * sets lastSavedTime, savedSubmissionLinks, savedSubmissionTitle and savedInput after success response
   */
  // Added a isSubmitted param to check if the function was called after click on submit button of pskill
  saveCurrentInput(isUserSaved:boolean, isSubmitted?:boolean) {
    // Do not save state if user is a teacher
    if (this.isPreviewMode) {
      return;
    }
    let currentTime = new Date();
    let currentInput = this.textEditor.getCurrentInput();
    let currentSubmissionTitle = this.currentSubmissionTitle.trim();
    let currentSubmissionLinks = [...this.currentSubmissionLinks];
    let itemid = this.pskill.itemid;
    let state = { };
    state[itemid]= {
        "data": currentInput,
        "timestamp" : currentTime.getTime(),
        "isUserSaved": isUserSaved
    };
    // save title and link to state
    if (this.pskillSubType === "cup-pskill-group" && this.groupId) {
      if (currentSubmissionTitle) {
        state[itemid]['attribs'] = {
          title: currentSubmissionTitle
        };
      }
      if (currentSubmissionLinks && currentSubmissionLinks.length > 0) {
        state[itemid]['link'] = currentSubmissionLinks;
      }
    }
    if (isUserSaved && !isSubmitted) {
      this.showSaveLoader = true;
    }        
    this.productViewHelperService.getXAPIAnalyticsObject().postStateNoBatch(this.pskill.itemid, state).then((response)=> {
      this.showSaveLoader = false;
      if (response && response.success && response.count === response.success.count) {
        this.lastSavedTime = currentTime;
        this.savedInput = currentInput;
        this.timeElapsedSinceLastSave = this.elapsedTimePipe.transform(this.lastSavedTime.getTime());
        this.isUserSaved = isUserSaved;
        if (this.groupId) {
          this.savedSubmissionTitle = currentSubmissionTitle;
          this.savedSubmissionLinks = [...currentSubmissionLinks];
        }
        this.chRef.detectChanges();
        this.isSaveAlertNeeded.emit(false);
      } else {
        this.handleStateSaveError(response, isUserSaved);
      }
    }, (error)=> {
      this.handleStateSaveError(error, isUserSaved);
    });
  }

  private handleStateSaveError(error: any, isUserSaved: boolean) {
    if (error.responseJSON && error.responseJSON.errorCode === 'LINK_ERROR') {
      this.productViewHelperService.pskillUrlLinkValidation.next(error);
      return;
    }
    this.showSaveLoader = false;
    this.urlValidationError = false;
    if (isUserSaved) {
      this.closeBtn.nativeElement.click();
      setTimeout(() => {
        this.showErrorModalBtn.nativeElement.click();
      }, 500);
    }
  }

  /**
   * handles user initiated save
   */
  userInitiatedSaved() {
    if(this.pskill.submissionType.id != 'speak') {
      this.saveCurrentInput(true);
    }
    if(this.closeBtn) this.closeBtn.nativeElement.click()
  }
  

  /**
   * registers the autosave counter
   */
  startAutoSaveCounter(){
    if(!this.autoSaveCounter){      
      this.autoSaveCounter = setInterval(()=>{
        let currentInput = this.textEditor.getCurrentInput();
        if(this.savedInput!=currentInput || this.currentSubmissionTitle.trim() !== this.savedSubmissionTitle
        || !this.compareArrayOfObjects(this.currentSubmissionLinks, this.savedSubmissionLinks)){
          this.saveCurrentInput(false);
        } else {
          this.isSaveAlertNeeded.emit(false);
        }
      }, 20000)

    }
  }

  /**
   * registers time elapsed counter
   */
  startTimeElapsedCounter(){
    if(!this.timeElapsedCounter){

      this.timeElapsedCounter = setInterval(()=>{
        if(this.lastSavedTime) {
          this.timeElapsedSinceLastSave =  this.elapsedTimePipe.transform(this.lastSavedTime.getTime());
        }        
      }, 10000)

    }
  }

  manageModal(){
    if (!this.showSaveLoader || !this.disableSaveAndSubmitButton) {
      this.hasClassStarted = ( new Date().getTime() - this.classData.startdate) >= 0;
    }
  }

  submittedBy(groupMemberData: any){
    if(!groupMemberData)
    {      
      /*
      * this only first time while user submit cup-pskill-group activity
      * As for first time data coming from api dosen't exist
      */
     return this.userProfileData.firstName + " " + this.userProfileData.lastName;
    }
    let userInfo = this.groupData.find((user)=>{
      return user.dls_user_id == groupMemberData.find((item:any)=> {return item.submitted;}).dls_user_id;
    });
    return userInfo ? userInfo.first_name + " " + userInfo.last_name : "";
  }
  
  ngOnDestroy() {
    //clear auto save counter
    if(this.autoSaveCounter) clearInterval(this.autoSaveCounter);
    if(this.timeElapsedCounter) clearInterval(this.timeElapsedCounter);
    if (this.changesNotSavedSubscription) {
        this.changesNotSavedSubscription.unsubscribe();
    }
    if (this.pskillSavedSubscription) {
        this.pskillSavedSubscription.unsubscribe();
    }
    if(this.pskillUrlLinkValidationSubscription) {
      this.pskillUrlLinkValidationSubscription.unsubscribe();
    }
    this.productViewHelperService.closeActivityBtnSubject.next({ visible: false });
  }

  setActivityDirty(generateLaunch = false, saveAlertNeeded = true) {
    this.isSaveAlertNeeded.emit(saveAlertNeeded);
    //start auto saving counters
    this.startAutoSaveCounter();
    this.startTimeElapsedCounter();
    if (generateLaunch && !this.launchedStatementGenerated && !this.isPreviewMode ) {
      this.productViewHelperService.getXAPIRunnerObject().generateCustomStatement(this.pskill.itemid, "launched");
      this.launchedStatementGenerated = true;
    }
  }

  showAddLinkModal() {
    if (this.currentSubmissionLinks.length >= this.maxSubmissionLinksAllowed) {
      return;
    }
    this.setActiveSubmissionLink(-1);
    this.showAddLinkModalBtn.nativeElement.click();
  }

  setActiveSubmissionLink(index) {
    this.activeSubmissionLinkIndex = index;
    this.activeSubmissionLink = Object.assign({}, this.currentSubmissionLinks[index]);
    if (!this.activeSubmissionLink) {
      this.activeSubmissionLink = {url: '', description: ''};
    }
  }

  saveCurrentSubmissionLink() {
    if (this.activeSubmissionLinkIndex === -1) {
      this.activeSubmissionLinkIndex = this.currentSubmissionLinks.length;
    }
    const link = {
      url: this.activeSubmissionLink.url.trim(),
      description: this.activeSubmissionLink.description && this.activeSubmissionLink.description.trim()
    }
    this.currentSubmissionLinks.splice(this.activeSubmissionLinkIndex, 1, link);
    this.setActivityDirty();
    this.addLinkForm.reset()
  }

  removeCurrentSubmissionLink() {
    this.currentSubmissionLinks.splice(this.activeSubmissionLinkIndex, 1);
    this.setActivityDirty();
  }

  // trim spaces from specific field
  trimSpaces(fieldCode) {
    const regex = /^\s+/g;
    if (fieldCode === 1 && this.currentSubmissionTitle) {
      this.currentSubmissionTitle = this.currentSubmissionTitle.replace(regex, '');
    } else if (fieldCode === 3 && this.activeSubmissionLink.description) {
      this.activeSubmissionLink.description = this.activeSubmissionLink.description.replace(regex, '');
    }
  }

  // Returns true if both arrays are same, else false
  compareArrayOfObjects(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      const elem1 = JSON.stringify(arr1[i]);
      const elem2 = JSON.stringify(arr2[i]);
      if (elem1 !== elem2) {
        return false;
      }
    }
    return true;
  }

}

